import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

const AQ_BASE_URL = process.env.REACT_APP_AQ_BASE_URL;

const EmailVerification = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleEmailVerification = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error('Email is required.');
      return;
    }

    setLoading(true);

    try {
      // API request using fetch
      const response = await fetch(
        `${AQ_BASE_URL}/aq/api/check_email_verification?email=${encodeURIComponent(email)}`,
        {
          method: 'POST',
          headers: {
            accept: 'application/json',
          },
        }
      );

      const data = await response.json(); // Parse JSON response

      if (response.ok && data.success) {
        if (data.verification_code) {
          toast.success('Verification code found. Proceeding to OTP verification.');
          navigate('/email-otp-verification', {
            state: { email, verification_code: data.verification_code },
          }); // Navigate to OTP Verification page
          localStorage.setItem('email', email); // Do this when the user enters their email
        } else {
          toast.error('No verification code set for this email.');
        }
      } else {
        toast.error(data.message || 'Failed to verify email. Try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('An error occurred. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white shadow-lg rounded-lg p-8 max-w-md w-full">
        <h2 className="text-xl text-center font-bold mb-2 text-black">Email Verification</h2>

        <h2 className="text-xs font-normal mb-6 text-gray-500 text-center">
          Enter your email address below. We will send you a verification code to confirm your
          identity.
        </h2>

        <form onSubmit={handleEmailVerification} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full rounded-md border border-black py-2 px-3 text-sm"
            />
          </div>

          <button
            type="submit"
            className="w-full rounded-md bg-green-700 py-2 text-sm font-semibold text-white hover:bg-green-800 transition duration-300"
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Verify Email'}
          </button>
        </form>

        <p className="mt-6 text-sm text-gray-600 text-center">
          Remember your password?
          <a href="/login" className="text-green-600 ml-1 hover:underline">
            Login
          </a>
        </p>
      </div>
      <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
    </div>
  );
};

export default EmailVerification;
